<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { useFormModel } from '@/hooks';

defineProps<{ text?: string }>();
const { setFormModel } = useFormModel();
defineExpose({ setFormModel });
</script>
<template>
  <nut-checkbox v-bind="$attrs">
    <template #icon v-if="$slots.icon"><slot name="icon" /></template>
    <template #checkedIcon v-if="$slots.checkedIcon">
      <slot name="checkedIcon" />
    </template>
    <template #indeterminate v-if="$slots.indeterminate">
      <slot name="indeterminate" />
    </template>
    <template #default v-if="$slots.default">
      <slot name="default" />
    </template>
    <template #default v-else>
      {{ text }}
    </template>
  </nut-checkbox>
</template>
